module.exports = __webpack_public_path__ + "static/upgrade.969f79ed.png";